import React from 'react';

import { RawPicture } from 'components/raw-picture';
import { IImageWidgetFragment } from 'generated/sanity-graphql';

type IBrandLogoProps = IImageWidgetFragment;

export const BrandLogo: React.FC<IBrandLogoProps> = ({ image, imageDescription }) => {
  return image?.locale ? (
    <RawPicture image={image?.locale} alt={imageDescription?.locale ?? ''} />
  ) : null;
};
